import script from "./DescrizioneOrdine.vue?vue&type=script&setup=true&lang=js"
export * from "./DescrizioneOrdine.vue?vue&type=script&setup=true&lang=js"

import "./DescrizioneOrdine.vue?vue&type=style&index=0&id=4722f0e4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4722f0e4"]])

export default __exports__